import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import { inlineDetailsStyles } from './css/new-styles';

export const InlineCouponDetails = injectSheet(inlineDetailsStyles)(({
  classes,
  coupon,
  messageKey,
  i18n,
}) => (
  <div className={classNames('inline-fac-coupon-details', classes.inlineCouponDetails)}>
    <span className={classes.couponIcon} />
    <span className={classes.inlineCouponDetailsText}>
      {i18n.getString(messageKey, coupon)}
    </span>
  </div>
));

InlineCouponDetails.propTypes = {
  coupon: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
  messageKey: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
